import { Card, CardContent } from "~/components/ui/card";
import clsx from "clsx"; // Install clsx if you don't have it: yarn add clsx
import { FactItemProps } from "./Interfaces/GeneralInterfaces";


export const QuickFactsTable = ({
  facts,
}: {
  facts: FactItemProps[];
}) => (
  <div className="mt-5">
    <Card className="border-none shadow-none">
      <CardContent className="py-4">
        <div className="flex items-start justify-start gap-6">
          {facts?.map((fact, idx) => {
            const isLast = idx === facts.length - 1;
            return (
              <div
                key={fact.label}
                className={clsx(
                  "flex items-center gap-2 md:gap-3 border-border",
                  { "border-r pr-6": !isLast }
                )}
              >
                <div className="bg-gray-50 p-3 rounded-lg ">
                  {fact.icon}
                </div>
                <div className="text-left space-y-0 md:space-y-1">
                  <p className="text-gray-500 text-sm hidden md:block">
                    {fact.label}
                  </p>
                  <p className="font-semibold text-sm">
                    {fact?.value === "Serviced Office (Classic)" ||
                      fact?.value === "Serviced Office (Creative)"
                      ? "Serviced Office"
                      : fact?.value}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  </div>

);